goog.provide("shadow.js.shim.module$src$svg$artwork$table_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$table_svg");
shadow.js.shim.module$src$svg$artwork$table_svg = shadow.js.nativeProvides["src/svg/artwork/table.svg"] = shadow$bridge("src/svg/artwork/table.svg");
module$shadow_js_shim_module$src$svg$artwork$table_svg.default = shadow.js.shim.module$src$svg$artwork$table_svg;
